import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedRepository } from '../../services/repositories/shared-repository';
import { ReportIssueRequest } from '../../types/shared.model';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ErrorDialogData {
  error: any;
  component?: string;
  isManualReport?: boolean;
}

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  standalone: false,
})
export class ErrorDialogComponent {
  userMessage = '';
  isSubmitting = false;

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData,
    private errorReportingRepo: SharedRepository,
    private snackBar: MatSnackBar,
  ) {}

  get isManualReport(): boolean {
    return !!this.data.isManualReport;
  }

  getStackTrace(): string {
    if (this.data.error instanceof Error) {
      return this.data.error.stack || 'No stack trace available';
    }
    return JSON.stringify(this.data.error, null, 2);
  }

  submitReport(): void {
    this.isSubmitting = true;

    const report: ReportIssueRequest = {
      userMessage: this.userMessage,
      stackTrace: this.isManualReport ? '' : this.getStackTrace(),
      componentName: this.data.component || 'Unknown',
      browserInfo: navigator.userAgent,
      url: window.location.href,
    };

    this.errorReportingRepo.submitReport(report).then((result) => {
      if (result.success) {
        this.snackBar.open(result.title || 'Report sent successfully. Thank you!', 'Close', {
          duration: 3000,
        });
        this.dialogRef.close();
      } else {
        // ApiService handles toaster for errors, but we can log or cleanup here
        this.isSubmitting = false;
      }
    });
  }
}
